// extracted by mini-css-extract-plugin
export var deleteIcon = "_ni-5";
export var deleteOption = "_ni-3";
export var divider = "_ni-2";
export var downloadIcon = "_ni-4";
export var drawer = "_ni-0";
export var drawerFooter = "_ni-6";
export var drawerOpen = "_ni-1";
export var highlighted = "_ni-7";
export var lighterHighlight = "_ni-8";